import { ApiResponse } from 'apisauce';

import api from '@/shared/config/http.config';
import {
  USER_PREFERENCE_CLIENT,
  USER_PREFERENCE_PLATFORM
} from '@/shared/constants/user-preference.constants';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import type {
  CommunicationLanguage,
  UpdateUserPreferencePayload,
  UserPreferenceApiResponse,
  UserPreferenceResponse
} from '@/shared/models/user-preference.model';

const apis = {
  getMyPreference: (): Promise<
    ApiResponse<UserPreferenceApiResponse<UserPreferenceResponse[] | null>, ErrorInfo>
  > =>
    api.get('/users/preference/me', {
      platform: USER_PREFERENCE_PLATFORM,
      client: USER_PREFERENCE_CLIENT
    }),

  updateMyPreference: (
    language: CommunicationLanguage
  ): Promise<ApiResponse<UserPreferenceApiResponse<UserPreferenceResponse>, ErrorInfo>> => {
    const payload: UpdateUserPreferencePayload = {
      platform: USER_PREFERENCE_PLATFORM,
      client: USER_PREFERENCE_CLIENT,
      language
    };
    return api.put('/users/preference/me', payload);
  }
};

export const userPreferenceApi = apis;
